"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spinner = void 0;
var _react = _interopRequireWildcard(require("react"));
var _usePalette = require("../hooks/usePalette");
var _linaria = require("../utils/linaria");
var styles = _interopRequireWildcard(require("./styles"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Spinner = /*#__PURE__*/(0, _react.memo)(function Spinner({
  size,
  color = 'foregroundMuted',
  testID,
  accessibilityLabel
}) {
  const palette = (0, _usePalette.usePalette)();
  const spinnerStyle = (0, _react.useMemo)(() => ({
    fontSize: `${size}px`,
    borderTopColor: palette.backgroundAlternate,
    borderRightColor: palette.backgroundAlternate,
    borderBottomColor: palette[color],
    borderLeftColor: palette.backgroundAlternate
  }), [palette, size, color]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    "aria-describedby": "spinnerStatus",
    className: (0, _linaria.cx)(styles.spinner.base, styles.spinnerAnimation),
    "data-testid": testID,
    role: "status",
    style: spinnerStyle
  }), /*#__PURE__*/_react.default.createElement("div", {
    "aria-live": "polite",
    className: styles.spinnerStatus,
    id: "spinnerStatus"
  }, accessibilityLabel));
});
exports.Spinner = Spinner;
Spinner.displayName = 'Spinner';